<template>
  <div class="h-100 move-container" :class="size" id="moveBody" @mousedown="onChangeStatus">
  </div>
</template>

<script>
export default {
  name: 'MoveHorizon',
  components: {},
  props: {
    min: { // 拖动最小值
      type: Number,
      default: 100
    },
    max: { // 拖动最大值
      type: Number,
      default: 550
    },
    size: { // 分为高的和矮的两种拖动类型 小的值为 small
      type: String,
      default: 'big'
    },
    moveId: {
      type: String,
      default: 'moveLeft'
    },
    moveDom: { // left, right
      type: String,
      default: 'left'
    }
  },
  data () {
    return {
      startX: 0
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onChangeStatus (e) {
      this.startX = e.clientX
      let that = this
      let moveLeft = document.getElementById(this.moveId)
      let width = parseFloat(moveLeft.style.width)
      document.onmousemove = evt => {
        let moveDistance = evt.clientX - that.startX
        let finalW = width + moveDistance
        if (that.moveDom === 'right') {
          finalW = width - moveDistance
        }
        moveLeft.style.width = finalW < that.min ? that.min : finalW > that.max ? that.max : finalW + 'px'
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.big:before {
  content: url("/static/images/yidongzuoyou.png");
  width: 16px;
  height: 24px;
  position: absolute;
  top: calc( 50% - 12px);
  left: -7px;
}
.small:before {
  content: url("/static/images/yidongicon.png");
  width: 16px;
  height: 30px;
  position: absolute;
  top: calc( 50% - 15px);
  left: -7px;
}
.move-container {
  width: 2px;
  background: #e5e5e5;
  position: relative;
  margin: 0 7px;
  /*box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);*/
  &:hover {
    cursor: e-resize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoveHorizon.vue